import moment from 'moment-timezone';
import InProductMessageParser from '@Containers/InProductMessages/InProductMessageParser';

export const PLACEHOLDERS_NAMES = {
  TIMESTAMP_FROM: 'TIMESTAMP_FROM',
  TIMESTAMP_END: 'TIMESTAMP_END',
};

export default class MaintainMessageParser extends InProductMessageParser {
  parse() {
    // Convert seconds to milliseconds
    const timestampFrom = this.placeholders[PLACEHOLDERS_NAMES.TIMESTAMP_FROM] * 1000;
    const timestampEnd = this.placeholders[PLACEHOLDERS_NAMES.TIMESTAMP_END] * 1000;
    const momentFrom = moment.utc(Number(timestampFrom)).local();
    const momentEnd = moment.utc(Number(timestampEnd)).local();
    const momentFromFormatted = momentFrom.format('DD.MM.YYYY h:mm A');
    const momentEndFormatted = momentEnd.isSame(momentFrom, 'day') ? momentEnd.format('h:mm A') : momentEnd.format('DD.MM.YYYY h:mm A');

    return this.message.replace(/%([^%]*)%/g, (m, p) => {
      const [k] = p.split('=');
      switch (k) {
        case PLACEHOLDERS_NAMES.TIMESTAMP_FROM:
          return momentFromFormatted;
        case PLACEHOLDERS_NAMES.TIMESTAMP_END:
          return momentEndFormatted;
        default:
          return '';
      }
    });
  }
}
